<template>
  <div ref="pageIndex" class="root">
    <Navigator
      :debugger="isDebugger"
      :isShowSlideBar="isShowSlideBar"
      :immersive="true"
    />
    <!-- 视频区 -->
    <VideoPlayer class="bury-point" showid="show_sgq90hBo" />
    <!-- 内容-->
    <Container ref="Container" />
  </div>
</template>

<script>
import mixin from '../attainment/mixin'

export default {
  mixins: [mixin],
  name: 'App',
  components: {
    'Navigator': () => import('../../../mall-www-source/src/components/navigator'),
    'Container': () => import('./components/container.vue'),
    'VideoPlayer': () => import('../../components/video-player')
  },
  data() {
    return {
      isDebugger: process.env.NODE_ENV === 'development' // navigator props
    }
  },
  mounted() {
    this.$eventBus.$emit('RouterPageMounted', this.$route.name)
  }
}
</script>

<style lang="scss" scoped>
.root {
  background: #FFFFFF;
  min-height: 100vh;
}
</style>
